var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-h1-inner.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isBrand")?(lineno = 0, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"brandNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")),"displayName"])):runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"h1Text"));
frame.set("crawlableMetaH1", t_1, true);
if(frame.topLevel) {
context.setVariable("crawlableMetaH1", t_1);
}
if(frame.topLevel) {
context.addExport("crawlableMetaH1", t_1);
}
output += "\n";
var t_2;
t_2 = "category_h1-wrapper_" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"key");
frame.set("localization_key", t_2, true);
if(frame.topLevel) {
context.setVariable("localization_key", t_2);
}
if(frame.topLevel) {
context.addExport("localization_key", t_2);
}
output += "\n\n<h1 class=\"c-category-header__seo-title js-category-h1\" data-qa-brand-title>\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"hasH1Override")) {
output += "\n    ";
output += runtime.suppressValue((lineno = 6, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "localization_key"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"refinement")),"value"),runtime.contextOrFrameLookup(context, frame, "crawlableMetaH1")]})])), env.opts.autoescape);
output += "\n";
;
}
else {
output += "\n    ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "crawlableMetaH1"), env.opts.autoescape);
output += "\n";
;
}
output += "\n</h1>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-h1-inner.j2"] , dependencies)